module.exports = __webpack_public_path__ + "static-v-shop/1782224859977/img/background.8dc9920d.png";